import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Sarah Johnson',
  location: 'United States',
  rating: 5,
  text: 'Our trip to Istanbul was absolutely amazing! Forsa Co. took care of every detail and the tour guides were incredibly knowledgeable. Will definitely book with them again!',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80'
}, {
  id: 2,
  name: 'Michael Chen',
  location: 'Canada',
  rating: 5,
  text: 'The Dubai luxury package exceeded all our expectations. The accommodations were top-notch and the itinerary was perfectly balanced. Thank you Forsa Co.!',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80'
}, {
  id: 3,
  name: 'Emma Wilson',
  location: 'United Kingdom',
  rating: 5,
  text: 'Thailand was breathtaking, and Forsa Co. made it stress-free. Their attention to detail and responsive customer service made all the difference.',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=688&q=80'
}];
const Testimonials = () => {
  return <section className="py-16 bg-gray-50" data-id="element-240">
      <div className="container mx-auto px-4" data-id="element-241">
        <div className="text-center mb-12" data-id="element-242">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-243">
            What Our Clients Say
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-244">
            Hear from travelers who have experienced unforgettable journeys with
            Forsa Co.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-245">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-white p-8 rounded-lg shadow-md" data-id="element-246">
              <div className="flex items-center mb-4" data-id="element-247">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-248" />
                <div data-id="element-249">
                  <h4 className="font-semibold" data-id="element-250">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm" data-id="element-251">
                    {testimonial.location}
                  </p>
                </div>
              </div>
              <div className="flex mb-4" data-id="element-252">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} size={18} className="text-yellow-400 fill-current" data-id="element-253" />)}
              </div>
              <p className="text-gray-700" data-id="element-254">{testimonial.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default Testimonials;